// src/components/Artists.styled.ts
import styled from "styled-components";


const breakpoints = {
  sm: "576px",
  md: "768px",
  lg: "992px",
  xl: "1200px",
};


export const Container = styled.div`
  padding: 2rem;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const Col = styled.div`
  width: 100%;
  max-width: 1200px;
`;

export const Title = styled.div`
  font-family: Verdana, Arial, sans-serif;
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 2rem;
`;

export const ArtistWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0rem;
  // padding-left: 20%;
  align-items: center; 
`;

export const ArtistRow = styled.div<{ $last?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: ${(props) => (props.$last ? "2rem" : "0")};
  max-width: 1000px;
  margin-left: 10%;
  margin-right: auto;

  @media (max-width: ${breakpoints.lg}) {
    flex-direction: column;
    align-items: center;
  }
`;


export const TextColumn = styled.div`
  flex-shrink: 0;
  width: 400px;
  padding-left: 15px;
  transition: all 0.3s ease;

  @media (max-width: 1150px) {
    padding-left: 10px;
    width: 350px;
  }

  @media (max-width: 1100px) {
    padding-left: 5px;
    width: 300px;
  }

  @media (max-width: 1050px) {
    padding-left: 2px;
    width: 270px;
  }

  @media (max-width: 1000px) {
    padding-left: 0;
    width: 250px;
  }

  @media (max-width: 992px) {
    width: 100%;
    padding-left: 0;
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    max-width: 220px; 
  }
`;

export const ImageColumn = styled.div`
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  flex-shrink: 0;

  @media (max-width: ${breakpoints.md}) {
    width: 100%;
    justify-content: center;
  }
`;



export const Image = styled.img`
  object-fit: cover;
  display: block;
  border-radius: 8px;

`;


export const Link = styled.a`
  color: inherit;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;


export const ArrowIcon = styled.img`
  margin-left: 0.5rem;
`;

export const ArtistText = styled.div`
  font-size: 0.85rem;
  color: #000;
`;

export const ArtistName = styled.span`
  display: block;
  font-weight: bold;
  margin-bottom: 0.5rem;
  color: black;
  margin-top:1rem;
`;
